module.exports = __webpack_public_path__ + "img/Unidad15-3.2f470955.png";